// src/Components/Header.js
import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";

class Header extends Component {
  render() {
    if (!this.props.data) return null;

    const github = this.props.data.github;
    const name = this.props.data.name;
    const description = this.props.data.description;
    const linkedin = this.props.data.linkedin;

    return (
      <header id="home">
        {/* background particles */}
        <ParticlesBg type="circle" bg={true} />

        <nav id="nav-wrap">
          {/* <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a> */}

          <ul id="nav" className="nav">
            <li className="current">
              <a className="smoothscroll" href="#home">
                Home
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#about">
                About
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#resume">
                Resume
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#portfolio">
                Works
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            {/* Name slides up first */}
            <Fade bottom duration={900} distance="20px">
              <h1 className="responsive-headline">{name}</h1>
            </Fade>

            {/* Description comes after */}
            <Fade bottom duration={1000} distance="20px" delay={250}>
              <h3>{description}</h3>
            </Fade>

            <hr />

            {/* Buttons appear last */}
            <Fade bottom duration={1100} distance="20px" delay={500}>
              <ul className="social">
                <a
                  href={github}
                  className="button btn github-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-github" />
                  Github
                </a>
                <a
                  href={linkedin}
                  className="button btn project-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-linkedin" />
                  LinkedIn
                </a>
              </ul>
            </Fade>
          </div>
        </div>

        {/* <p className="scrolldown">
          <a className="smoothscroll" href="#about">
            <i className="icon-down-circle" />
          </a>
        </p> */}
      </header>
    );
  }
}

export default Header;
